var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00033 0.166748C4.39795 0.166748 0.666992 3.89771 0.666992 8.50008C0.666992 13.1025 4.39795 16.8334 9.00033 16.8334C13.6027 16.8334 17.3337 13.1025 17.3337 8.50008C17.3337 3.89771 13.6027 0.166748 9.00033 0.166748ZM5.91107 5.41083C6.23651 5.08539 6.76414 5.08539 7.08958 5.41083L9.00033 7.32157L10.9111 5.41083C11.2365 5.08539 11.7641 5.08539 12.0896 5.41083C12.415 5.73626 12.415 6.2639 12.0896 6.58934L10.1788 8.50008L12.0896 10.4108C12.415 10.7363 12.415 11.2639 12.0896 11.5893C11.7641 11.9148 11.2365 11.9148 10.9111 11.5893L9.00033 9.67859L7.08958 11.5893C6.76414 11.9148 6.23651 11.9148 5.91107 11.5893C5.58563 11.2639 5.58563 10.7363 5.91107 10.4108L7.82182 8.50008L5.91107 6.58934C5.58563 6.2639 5.58563 5.73626 5.91107 5.41083Z",
    fill: "#E74646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.08839de5fec8c1d93a2c4d45a2b10371.svg";
export { ForwardRef as ReactComponent };